import type { Model } from '@patsnap/tahiti-core';
import type { SpecificationConfirmClaimsState } from '../types/specification-confirm-claims';

export const SpecificationConfirmClaimsModel = Symbol.for('SpecificationConfirmClaimsModel');

export interface SpecificationConfirmClaimsModel extends Model<SpecificationConfirmClaimsState> {}
